module.exports = __webpack_public_path__ + "img/login_04.c6f12f5f.jpg";